import type { AxiosResponse } from 'axios';

import type { DepositSettingsResponse } from '@/interfaces/user';

import request from '../request';

export const getDepositSettings = async (): Promise<AxiosResponse<DepositSettingsResponse>> => {
  const response = await request({
    method: 'GET',
    requiresLatLong: true,
    url: '/user/deposit_settings',
    underdogAPIVersion: 'v3',
  });

  return response;
};
